module.exports = __webpack_public_path__ + "static/media/google-white.6307bf19.png";